import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "/api";

const STATUS_CONFIG = {
  fresh: { emoji: "🟢", label: "Dados atualizados", color: "#2e7d32" },
  stale: { emoji: "🟡", label: "Dados com atraso", color: "#f57f17" },
  outdated: { emoji: "🔴", label: "Dados desatualizados", color: "#c62828" },
};

export default function DataFreshness() {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE}/freshness`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, []);

  if (!data) return null;

  const config = STATUS_CONFIG[data.status] || STATUS_CONFIG.outdated;
  const latestFormatted = new Date(data.latest_date).toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div className="data-freshness" style={{ borderLeftColor: config.color }}>
      <span className="freshness-status">
        {config.emoji} {config.label}
      </span>
      <span className="freshness-detail">
        Última coleta: <strong>{latestFormatted}</strong>
        {data.days_since_update > 0 && (
          <span className="freshness-days">
            {" "}({data.days_since_update} {data.days_since_update === 1 ? "dia" : "dias"} atrás)
          </span>
        )}
      </span>
      <span className="freshness-records">
        {data.total_records.toLocaleString("pt-BR")} registros · Fonte: ANP
      </span>
    </div>
  );
}
